import React, { useState, useEffect } from 'react';
import axios from 'axios';

import { shopContext } from '../../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import { chatbotApi } from '../../../common/src';
import { toast } from 'react-toastify';
import moment from 'moment';

const WidgetMemberShipOrderList = (props) => {
  const { loginId, history } = props;
  const [list, setList] = useState(null);
  //   const preText = props.childProps.state.prevMessage;
  //   const _prev = () => {
  //     props.childProps.actionProvider._categoryPrev(preText);
  //   };
  const _goHome = () => {
    props.childProps.actionProvider._home(-1);
  };
  const _more = () => {
    history.push('/mypage/4');
  };
  const _goMy = (orderCode) => {};
  const _getData = async () => {
    if (loginId === undefined || loginId === null || loginId === '') {
      toast.warn('로그인후 이용 가능한 서비스입니다.');
    } else {
      const result = await axios.post(
        chatbotApi + '/api/getMembershipOrderList',
        {
          userid: loginId,
        }
      );
      //   //console.log(result);

      const intReturn = result.data.intReturn;
      //console.log(intReturn);
      //console.log(result.data.listData);
      if (intReturn === 0) {
        setList(result.data.listData);
      }
    }
  };
  const _addComma = (price) => {
    let returnString = price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return returnString;
  };
  useEffect(() => {
    _getData();
  }, []);
  return (
    <>
      <div className="order-container">
        <div>
          <h1>멤버십 구매 내역</h1>
        </div>
        <div className="order-info">
          <div>
            <table>
              <thead>
                <tr>
                  <th>상품명</th>
                  {/* <th>결제금액</th>
                  <th>구분</th> */}
                </tr>
              </thead>
              <tbody>
                {list ? (
                  list.map((item) => (
                    <tr>
                      <td>
                        <span>[주문번호: {item.orderCode}]</span>
                        <br />
                        {item.freePassName}
                        <br />
                        <em>결제 금액: {_addComma(item.freePassPrice)}</em>
                        <em>
                          결제일:{' '}
                          {moment(item.regDate).format('YYYY.MM.DD hh:mm')}
                        </em>
                        <div onClick={() => _goMy(item.orderCode)}>
                          바로가기
                        </div>
                      </td>
                      {/* <td>{item.sumPrice}</td>
                      <td>환불/취소</td> */}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td>환불 가능한 결제내역이 존지하지 않습니다.</td>
                  </tr>
                )}
                <tr>
                  <div className="refund-info">
                    결제일 기준 만 7일 이내, 결제 취소 환불 신청이 가능합니다.
                    <br />
                    <br />
                    - 단, 아래와 같은 경우 환불이 불가합니다.
                    <br />
                    <br />
                    - 해당 멤버십 기간 중 멤버십 서비스 이용 내역이 1건 이상
                    있을 경우.
                    <br />
                    <br />
                    멤버십 결제로 지급된 혜택/서비스를 이용했을 경우.
                    <br />
                    <br />
                    결제일 기준 7일을 경과하여 환불을 신청했을 경우.
                  </div>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="program-more" onClick={_more}>
          결제내역 자세히 보기
        </div>
        {/* <div className="program-home" onClick={_goHome}>
          처음으로
        </div> */}
      </div>
      <div className="prev-chat-container">
        <div className="prev-contaner">
          <div onClick={_goHome} className="prev">
            <img src="/img/chatbot/icon_home.png" />
            처음으로
          </div>
        </div>
      </div>
    </>
  );
};

export default shopContext(withRouter(WidgetMemberShipOrderList));
